import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store";
import { ModalProvider } from './components/CustomModal/ModalProvider.jsx';
import { readStoredTheme, applyThemeToDocument } from "./utils/themePreference";

// Aplica o tema salvo antes do primeiro render para evitar flash de tema.
// Padrão da API: "light" quando nunca houve preferência salva.
applyThemeToDocument(readStoredTheme());

const router = createBrowserRouter([
  {
    path: "/*",
    element: <App />,
  }
], {
  future: {
    v7_startTransition: true, // Ativa a transição antecipadamente
    v7_relativeSplatPath: true,
  }
});


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <ModalProvider>
      <RouterProvider router={router} />
    </ModalProvider>
  </Provider>
);

reportWebVitals();
